<template>
	<div class="interested lead mt-3">
		<b-form-checkbox v-model="selected" unchecked-value="false">
			Me interesa este servicio
		</b-form-checkbox>
	</div>
</template>

<script>
	export default {
		name: 'v-interested',
		props: {
			service_type_id: {default: null},
			value: {default: null},
		},
		components:{
		},
		data(){
			return {
				selected: false,
				check: false
			}
		},
		methods:{
			checked(evt){
				if(this.selected == true)
					if(this.$store.state.isLogged){
							evt.target.checked = true;				
					}else{
						evt.target.checked = false;				
						this.$store.commit('set_login_favorite', {});
						this.$bvModal.show('modal-login');
					}
			}
		},
		watch: {
			selected: {
				handler: function() {
					if(this.selected == true)
						if(this.$store.state.isLogged){
							this.axios.post("complementary_services",{service_type_id: this.service_type_id, value: this.value}).then(response => {
								this.deliverys = response.data.TarifasComuna
							})
						}else{
							this.$store.commit('set_login_favorite', {});
							this.$bvModal.show('modal-login');
						}
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>